import type { Phrase } from '../types';
import type { pagesEn } from './pages.en';

export const pagesMl: Partial<Record<keyof typeof pagesEn, Phrase>> = {
  // shared
  pgVenueCount: { one: 'അനുയോജ്യമായ {count} വേദി', other: 'അനുയോജ്യമായ {count} വേദികൾ' },
  pgVenueCountNone: 'വേദികൾ ഉടൻ ചേരുന്നു',
  pgVenues: { one: '{count} വേദി', other: '{count} വേദികൾ' },
  pgBrowseAll: 'എല്ലാ വേദികളും കാണുക',
  pgFindVenue: 'വേദി കണ്ടെത്തുക',
  pgLoadError: 'ഇപ്പോൾ വേദികൾ ലോഡ് ചെയ്യാനായില്ല. കണക്ഷൻ പരിശോധിച്ച് വീണ്ടും ശ്രമിക്കുക.',
  pgRetry: 'വീണ്ടും ശ്രമിക്കുക',
  pgBreadcrumb: 'പേജ് പാത',
  pgReadMins: '{count} മിനിറ്റ് വായന',
  pgReadGuide: 'ഗൈഡ് വായിക്കുക',
  pgEnglishOnly: 'ഈ ഗൈഡ് ഇംഗ്ലീഷിലാണ്.',
  pgCtaTitle: 'തീയതിയും അതിഥികളുടെ എണ്ണവും തീരുമാനിച്ചോ?',
  pgCtaBody:
    'നഗരം, തീയതി, ശേഷി എന്നിവ വച്ച് തിരയുക, ഒഴിവുള്ള സെഷനുകൾ കാണുക, വേദിക്ക് അഭ്യർത്ഥന അയയ്ക്കുക. ഓൺലൈനായി ഒന്നും അടയ്ക്കേണ്ടതില്ല.',

  // event types
  pgOccEyebrow: 'പരിപാടികൾ',
  pgOccTitle: 'ഓരോ പരിപാടിക്കും അനുയോജ്യമായ ഇടങ്ങൾ',
  pgOccLead:
    'നിങ്ങൾ ആസൂത്രണം ചെയ്യുന്ന പരിപാടിയിൽ നിന്ന് തുടങ്ങൂ. ഓരോന്നിനും പ്രായോഗിക നിർദ്ദേശങ്ങളും, സൗകര്യങ്ങൾ കൊണ്ട് സാധാരണയായി ചേരുന്ന വേദികളും ഇവിടെയുണ്ട്.',
  pgOccGroupsEyebrow: 'അവസരങ്ങൾ',
  pgOccGroupsTitle: 'നിങ്ങളുടെ അവസരം തിരഞ്ഞെടുക്കുക',
  pgOccGroupsSub: 'ഓരോന്നിനും ആസൂത്രണ നിർദ്ദേശങ്ങൾ, അനുയോജ്യമായ വേദികൾ, ഗൈഡുകൾ.',
  pgOccOpen: 'നിർദ്ദേശങ്ങളും വേദികളും',
  pgAllTypesEyebrow: 'പരിപാടി അനുസരിച്ച്',
  pgAllTypesTitle: 'എല്ലാ പരിപാടി തരങ്ങളും',
  pgAllTypesSub: 'ഒരു പ്രത്യേക പരിപാടിക്ക് സാധാരണ ചേരുന്ന വേദികളിലേക്ക് നേരിട്ട് പോകൂ.',

  // one occasion
  pgOccNotFoundTitle: 'ആ അവസരം കണ്ടെത്താനായില്ല',
  pgOccNotFoundBody: 'ലിങ്ക് പഴയതായിരിക്കാം. എല്ലാ പരിപാടി തരങ്ങളും ഒരു പേജിൽ കാണാം.',
  pgOccVenuesTitle: '{name}: അനുയോജ്യമായ വേദികൾ',
  pgOccVenuesEmptyTitle: 'ഇതുവരെ അനുയോജ്യമായ വേദികളില്ല',
  pgOccVenuesEmptyBody: 'പുതിയ വേദികൾ ചേർന്നുകൊണ്ടിരിക്കുന്നു. അതുവരെ എല്ലാ വേദികളും നഗരവും അതിഥികളുടെ എണ്ണവും വച്ച് തിരയാം.',
  pgOccEventsTitle: 'പരിപാടി അനുസരിച്ച് തിരയുക',
  pgOccGuidesEyebrow: 'ബുക്ക് ചെയ്യും മുൻപ് വായിക്കുക',
  pgOccGuidesTitle: 'ആസൂത്രണ ഗൈഡുകൾ',
  pgOccSeeAll: 'ഈ അവസരത്തിനുള്ള എല്ലാ വേദികളും',

  // weddings
  pgTipWed1: 'അതിഥികളുടെ യഥാർത്ഥ എണ്ണം',
  pgTipWed1Body:
    'യഥാർത്ഥ അതിഥി എണ്ണം ഹാളിന്റെ ഇരിപ്പിട ശേഷിയും ഫ്ലോട്ടിംഗ് ശേഷിയുമായി താരതമ്യം ചെയ്യുക. ചടങ്ങിന്റെ സമയത്താണ് തിരക്ക് കൂടുക; ഭക്ഷണം സാധാരണ പന്തികളായാണ് വിളമ്പുക.',
  pgTipWed2: 'ഭക്ഷണശാലയും കാറ്ററിംഗ് നിയമങ്ങളും',
  pgTipWed2Body:
    'ഭക്ഷണശാലയിൽ ഒരേ സമയം എത്ര പേർക്ക് ഇരിക്കാമെന്നും, സദ്യയ്ക്ക് വേദിയുടെ കാറ്ററർ നിർബന്ധമാണോ അതോ സ്വന്തമായി കൊണ്ടുവരാമോ എന്നും ചോദിക്കുക.',
  pgTipWed3: 'കാറിനും ഇരുചക്ര വാഹനങ്ങൾക്കും പാർക്കിംഗ്',
  pgTipWed3Body: 'വിവാഹ അതിഥികൾ ഒരുമിച്ചാണ് എത്തുക. രണ്ടിനുമുള്ള പാർക്കിംഗും, മുതിർന്നവരെ വാതിൽക്കൽ ഇറക്കാനുള്ള സ്ഥലവും ഉറപ്പാക്കുക.',
  pgTipWed4: 'ഫോട്ടോയ്ക്ക് ഭംഗിയുള്ള വേദി',
  pgTipWed4Body:
    'സ്റ്റേജിന്റെ വലിപ്പം, പശ്ചാത്തലം, വെളിച്ചം എന്നിവയും മുന്നിൽ ഫോട്ടോഗ്രാഫർമാർക്കും വീഡിയോയ്ക്കുമുള്ള സ്ഥലവും നോക്കുക.',
  pgTipWed5: 'കുടുംബങ്ങൾക്കുള്ള മുറികൾ',
  pgTipWed5Body: 'സ്റ്റേജിനടുത്ത് വധുവിനുള്ള മുറിയും വസ്ത്രം മാറാനുള്ള മുറിയും ഉണ്ടെങ്കിൽ അന്നത്തെ ഓട്ടം ഏറെ കുറയും.',
  pgTipWed6: 'എല്ലാം പ്രവർത്തിപ്പിക്കുന്ന പവർ ബാക്കപ്പ്',
  pgTipWed6Body: 'ജനറേറ്റർ ഫാനുകൾ മാത്രമല്ല, എസി, ലൈറ്റുകൾ, ശബ്ദസംവിധാനം എന്നിവയും പ്രവർത്തിപ്പിക്കുമോ എന്ന് ചോദിക്കുക.',

  // conferences
  pgTipConf1: 'സ്ക്രീൻ, ശബ്ദം, പ്രൊജക്ടർ',
  pgTipConf1Body:
    'പ്രൊജക്ടർ അല്ലെങ്കിൽ എൽഇഡി സ്ക്രീൻ, എത്ര വയർലെസ് മൈക്കുകൾ, പോഡിയത്തിൽ ലാപ്ടോപ്പ് എങ്ങനെ ബന്ധിപ്പിക്കും എന്നിവ ഉറപ്പാക്കുക.',
  pgTipConf2: 'ഇരിപ്പിട രീതി',
  pgTipConf2Body:
    'തിയേറ്റർ രീതിയിൽ ഏറ്റവും കൂടുതൽ പേർക്ക് ഇരിക്കാം; മേശകളുള്ള ക്ലാസ്റൂം രീതിയിൽ കുറവാണെങ്കിലും കുറിപ്പെടുക്കാൻ സൗകര്യമാണ്. ഹാളിൽ എന്തെല്ലാം ഒരുക്കാമെന്ന് ചോദിക്കുക.',
  pgTipConf3: 'രജിസ്ട്രേഷനും ബ്രേക്ക്ഔട്ട് മുറികളും',
  pgTipConf3Body: 'രജിസ്ട്രേഷൻ ഡെസ്കിന് ഒരു ഫോയറും, സമാന്തര സെഷനുകളുണ്ടെങ്കിൽ പ്രത്യേക മുറികളും നോക്കുക.',
  pgTipConf4: 'എസിയും പവർ ബാക്കപ്പും',
  pgTipConf4Body: 'അടച്ച ഹാളിൽ ഒരു മുഴുവൻ ദിവസത്തിന് വിശ്വസനീയമായ എസിയും എവി ഉപകരണങ്ങൾ പ്രവർത്തിപ്പിക്കുന്ന ജനറേറ്ററും വേണം.',
  pgTipConf5: 'അവതാരകർക്ക് ഇന്റർനെറ്റ്',
  pgTipConf5Body: 'വൈ-ഫൈ ഉണ്ടോ, എത്ര പേർക്ക് ഉപയോഗിക്കാം എന്ന് ചോദിക്കുക. ബാക്കപ്പായി ഒരു മൊബൈൽ ഹോട്ട്സ്പോട്ട് കരുതുക.',
  pgTipConf6: 'എത്തിച്ചേരാനുള്ള സൗകര്യം',
  pgTipConf6Body: 'പാർക്കിംഗ്, മുകൾ നിലകളിലേക്ക് ലിഫ്റ്റ്, ദൂരെ നിന്നുള്ള പ്രതിനിധികൾക്ക് വേദിയിലെത്താനുള്ള എളുപ്പം.',

  // seminars
  pgTipSem1: 'യോജിച്ച വലിപ്പമുള്ള മുറി',
  pgTipSem1Body: 'പകുതി ഒഴിഞ്ഞ ഹാൾ മങ്ങിയതായി തോന്നും. രജിസ്ട്രേഷനോട് അടുത്ത, അല്പം അധിക സ്ഥലമുള്ള മുറി തിരഞ്ഞെടുക്കുക.',
  pgTipSem2: 'പഠനത്തിനുള്ള ഇരിപ്പിടം',
  pgTipSem2Body: 'എഴുതുകയോ ഒരുമിച്ച് പ്രവർത്തിക്കുകയോ ചെയ്യുന്ന വർക്ക്ഷോപ്പുകൾക്ക് ക്ലാസ്റൂം അല്ലെങ്കിൽ യു-ആകൃതി; പ്രഭാഷണങ്ങൾക്ക് തിയേറ്റർ രീതി.',
  pgTipSem3: 'സ്ക്രീനും എഴുതാനുള്ള സൗകര്യവും',
  pgTipSem3Body: 'പിൻനിരയിൽ നിന്ന് സ്ക്രീൻ വായിക്കാനാകുമോ എന്ന് നോക്കുക; വൈറ്റ്ബോർഡോ ഫ്ലിപ് ചാർട്ടോ ഉണ്ടോ എന്ന് ചോദിക്കുക.',
  pgTipSem4: 'ശരിയായ സെഷൻ',
  pgTipSem4Body: 'നിങ്ങളുടെ അജണ്ടയ്ക്ക് ചേരുന്ന രാവിലെ, ഉച്ചകഴിഞ്ഞ്, അല്ലെങ്കിൽ മുഴുദിവസ സെഷൻ ഒരുക്കാനുള്ള സമയം ഉൾപ്പെടെ ബുക്ക് ചെയ്യുക.',
  pgTipSem5: 'ചായയും ഉച്ചഭക്ഷണവും',
  pgTipSem5Body: 'മുറിയെ ശല്യപ്പെടുത്താതെ ലഘുഭക്ഷണം എവിടെ വിളമ്പാമെന്നും വേദിയുടെ കാറ്ററിംഗ് നിയമങ്ങളും ചോദിക്കുക.',

  // cultural
  pgTipCul1: 'സ്റ്റേജിന്റെ വലിപ്പവും വിങ്ങുകളും',
  pgTipCul1Body: 'ഏറ്റവും വലിയ ഇനത്തിന് സ്റ്റേജ് മതിയാകുമോ എന്ന് അളക്കുക; പ്രവേശനത്തിന് വിങ്ങുകളോ ബാക്ക്സ്റ്റേജോ ഉണ്ടോ എന്ന് നോക്കുക.',
  pgTipCul2: 'ശബ്ദവും വെളിച്ചവും',
  pgTipCul2Body: 'ഏത് ശബ്ദസംവിധാനവും സ്റ്റേജ് ലൈറ്റുകളും ഉൾപ്പെടുന്നുവെന്നും, നിങ്ങളുടെ സാങ്കേതിക വിദഗ്ധർക്ക് അവ ഉപയോഗിക്കാമോ എന്നും ചോദിക്കുക.',
  pgTipCul3: 'എല്ലാവർക്കും കാഴ്ച',
  pgTipCul3Body: 'തട്ടുതട്ടായുള്ള ഇരിപ്പിടം എല്ലാവർക്കും കാഴ്ച നൽകും. നിരപ്പായ തറയിൽ ഉയർന്ന സ്റ്റേജ് കൂടുതൽ പ്രധാനമാണ്.',
  pgTipCul4: 'ഗ്രീൻ റൂമുകൾ',
  pgTipCul4Body: 'കലാകാരന്മാർക്ക് സ്റ്റേജിനടുത്ത് കണ്ണാടി, വെളിച്ചം, പ്ലഗ് പോയിന്റുകൾ എന്നിവയുള്ള മുറികൾ വേണം.',
  pgTipCul5: 'റിഹേഴ്സലിനുള്ള സമയം',
  pgTipCul5Body: 'കാണികൾ എത്തുന്നതിന് മുൻപ് ഒരുക്കത്തിനും പൂർണ്ണ സൗണ്ട് ചെക്കിനും മതിയായ സമയം ബുക്ക് ചെയ്യുക.',

  // celebrations
  pgTipCel1: 'അതിഥികൾക്ക് ചേരുന്ന വലിപ്പം',
  pgTipCel1Body: 'ഒഴിഞ്ഞുകിടക്കുന്ന ഹാളിനെക്കാൾ നിറഞ്ഞ ഹാളാണ് നല്ലത്. വട്ടമേശകൾക്ക് വരികളെക്കാൾ ഒരാൾക്ക് കൂടുതൽ സ്ഥലം വേണം.',
  pgTipCel2: 'ഭക്ഷണവും കേക്കും',
  pgTipCel2Body: 'പുറത്തുനിന്നുള്ള കാറ്ററിംഗോ സ്വന്തം കേക്കോ അനുവദിക്കുമോ, എവിടെ വിളമ്പാം എന്ന് ഉറപ്പാക്കുക.',
  pgTipCel3: 'അലങ്കാര നിയമങ്ങൾ',
  pgTipCel3Body: 'ബലൂണുകൾ, ലൈറ്റുകൾ, പശ്ചാത്തലം — എന്തെല്ലാം വയ്ക്കാമെന്നും അലങ്കാരക്കാർക്ക് എപ്പോൾ എത്താമെന്നും ചോദിക്കുക.',
  pgTipCel4: 'സംഗീതവും അവസാനിക്കുന്ന സമയവും',
  pgTipCel4Body: 'ശബ്ദ പരിധികളും പരിപാടി അവസാനിപ്പിക്കേണ്ട സമയവും ഉറപ്പാക്കുക, പ്രത്യേകിച്ച് വൈകുന്നേര പാർട്ടികൾക്ക്.',
  pgTipCel5: 'കുട്ടികളും മുതിർന്നവരും',
  pgTipCel5Body: 'കുട്ടികൾക്ക് സുരക്ഷിതമായ ഒരിടം, മുതിർന്നവർക്ക് പ്രവേശന കവാടത്തിനടുത്ത് ഇരിപ്പിടം, ആവശ്യമെങ്കിൽ ലിഫ്റ്റോ റാമ്പോ.',

  // corporate
  pgTipCorp1: 'ബ്രാൻഡിന് ഇടം',
  pgTipCorp1Body: 'ബ്രാൻഡ് പശ്ചാത്തലം, സ്റ്റാൻഡികൾ, പ്രഭാഷകർക്കും ഉൽപ്പന്ന പ്രദർശനത്തിനുമുള്ള സ്റ്റേജ് എന്നിവയ്ക്ക് സ്ഥലമുണ്ടോ എന്ന് നോക്കുക.',
  pgTipCorp2: 'പ്രവർത്തിക്കുന്ന എവി',
  pgTipCorp2Body: 'പ്രൊജക്ടർ അല്ലെങ്കിൽ എൽഇഡി സ്ക്രീൻ, വയർലെസ് മൈക്കുകൾ, പരിപാടി മുഴുവൻ ഒരു ടെക്നീഷ്യൻ.',
  pgTipCorp3: 'വരവും ചെക്ക്-ഇന്നും',
  pgTipCorp3Body: 'ചെക്ക്-ഇന്നിന് ഒരു സ്വീകരണ സ്ഥലം, സുഖകരമായ ഇരിപ്പിടം, ഭക്ഷണത്തിന് പ്രത്യേക ഇടം.',
  pgTipCorp4: 'വിശ്വാസ്യത ആദ്യം',
  pgTipCorp4Body: 'അലങ്കാരത്തെക്കാൾ പ്രധാനം എസി, പവർ ബാക്കപ്പ്, ഉറപ്പിച്ച സമയക്രമം എന്നിവയാണ്.',
  pgTipCorp5: 'കണക്കുകൾക്ക് രസീത്',
  pgTipCorp5Body: 'പണം അടയ്ക്കുമ്പോൾ വേദിയോട് രസീത് ചോദിക്കുക.',

  // locations
  pgLocEyebrow: 'സ്ഥലങ്ങൾ',
  pgLocTitle: 'നഗരം അനുസരിച്ച് വേദികൾ',
  pgLocLead: 'ഇവിടെയുള്ള ഓരോ നഗരത്തിലും ഇന്ന് അഭ്യർത്ഥിക്കാവുന്ന വേദികളുണ്ട്. വേദികൾ, നിരക്കുകൾ, ഒഴിവുള്ള തീയതികൾ കാണാൻ ഒന്ന് തിരഞ്ഞെടുക്കുക.',
  pgLocUpTo: '{count} അതിഥികൾ വരെ',
  pgLocView: '{city}-ലെ വേദികൾ കാണുക',
  pgLocPhotoAlt: '{city}-ലെ ഒരു വേദി',
  pgLocEmptyTitle: 'ഇതുവരെ നഗരങ്ങളൊന്നുമില്ല',
  pgLocEmptyBody: 'വേദികൾ പരിശോധിച്ചുകൊണ്ടിരിക്കുന്നു, ഉടൻ ഇവിടെ കാണാം. ഇപ്പോഴുള്ളവ ബ്രൗസ് ചെയ്യാം.',

  // inspiration
  pgInspEyebrow: 'ആശയങ്ങൾ',
  pgInspTitle: 'പരിപാടി ആസൂത്രണത്തിനുള്ള ഗൈഡുകൾ',
  pgInspLead: 'ഹാൾ തിരഞ്ഞെടുക്കാനും ഒരുക്കാനും വിശദാംശങ്ങൾ ശരിയാക്കാനുമുള്ള പ്രായോഗിക നിർദ്ദേശങ്ങൾ, കേരളത്തിലെ പരിപാടികൾക്കായി.',
  pgInspFilter: 'വിഷയം അനുസരിച്ച് ഗൈഡുകൾ',
  pgCatAll: 'എല്ലാം',
  pgCatPlanning: 'ആസൂത്രണം',
  pgCatWeddings: 'വിവാഹം',
  pgCatCorporate: 'കോർപ്പറേറ്റ്',
  pgCatVenues: 'വേദികൾ',
  pgFeatured: 'പ്രധാന ഗൈഡ്',
  pgInspEmpty: 'ഈ വിഷയത്തിൽ ഇതുവരെ ഗൈഡുകളില്ല.',
  pgInspCtaTitle: 'വേദികൾ നോക്കാൻ തയ്യാറാണോ?',
  pgInspCtaBody: 'നഗരം, തീയതി, അതിഥികളുടെ എണ്ണം വച്ച് തിരയുക, രണ്ട് വേദികൾ അടുത്തടുത്ത് താരതമ്യം ചെയ്യുക.',

  // article
  pgArtNotFoundTitle: 'ആ ഗൈഡ് കണ്ടെത്താനായില്ല',
  pgArtNotFoundBody: 'അത് മാറ്റിയിരിക്കാം. ഞങ്ങളുടെ എല്ലാ ഗൈഡുകളും ഒരു പേജിലുണ്ട്.',
  pgAllGuides: 'എല്ലാ ഗൈഡുകളും',
  pgTip: 'നുറുങ്ങ്',
  pgPlanTitle: 'Aghosha-യോടൊപ്പം ആസൂത്രണം ചെയ്യൂ',
  pgPlanBody:
    'നഗരവും അതിഥികളുടെ എണ്ണവും വച്ച് വേദികൾ തിരയുക, നിങ്ങളുടെ തീയതിയിലെ ഒഴിവുള്ള സെഷനുകൾ നോക്കുക, അഭ്യർത്ഥന അയയ്ക്കുക. വേദി അത് സ്ഥിരീകരിക്കും, പണം നേരിട്ട് വേദിക്ക് നൽകാം.',
  pgPlanOccasions: 'പരിപാടി തരം അനുസരിച്ച്',
  pgMoreGuides: 'കൂടുതൽ ഗൈഡുകൾ',

  // about
  pgAboutEyebrow: 'Aghosha-യെക്കുറിച്ച്',
  pgAboutTitle: 'പരിപാടിക്ക് വേദി കണ്ടെത്താനും ബുക്ക് ചെയ്യാനും ഒരു എളുപ്പവഴി',
  pgAboutLead:
    'ഓഡിറ്റോറിയങ്ങൾ, വിവാഹ ഹാളുകൾ, ബാങ്ക്വറ്റ് ഹാളുകൾ, കൺവെൻഷൻ സെന്ററുകൾ — യഥാർത്ഥ ശേഷിയും നിരക്കും ഒഴിവുള്ള തീയതികളും സഹിതം ഒരിടത്ത്. ആസൂത്രണം തുടങ്ങുന്നത് ഫോൺ വിളികളിൽ നിന്നല്ല, വസ്തുതകളിൽ നിന്നാണ്.',
  pgAboutWhoEyebrow: 'ആർക്കുവേണ്ടി',
  pgAboutWhoTitle: 'ബുക്കിംഗിന്റെ ഇരുവശത്തിനും വേണ്ടി',
  pgAboutGuestsTitle: 'പരിപാടി ആസൂത്രണം ചെയ്യുന്നവർ',
  pgAboutGuestsBody:
    'വിവാഹം ഒരുക്കുന്ന കുടുംബങ്ങൾ, കോൺഫറൻസ് നടത്തുന്ന സ്ഥാപനങ്ങൾ, പരിപാടി സംഘടിപ്പിക്കുന്ന കൂട്ടായ്മകൾ. ഒരു ഫോൺ വിളിക്കും മുൻപേ ശേഷി, സൗകര്യങ്ങൾ, നിരക്ക്, ഒഴിവുള്ള തീയതികൾ എന്നിവ വച്ച് ഹാളുകൾ താരതമ്യം ചെയ്യാം.',
  pgAboutOwnersTitle: 'വേദി ഉടമകളും മാനേജർമാരും',
  pgAboutOwnersBody:
    'ഹാളുകൾ ഒരിക്കൽ ലിസ്റ്റ് ചെയ്യുക, ബുക്കിംഗ് അഭ്യർത്ഥനകൾ സ്വീകരിക്കുക, എല്ലാ ഹാളുകൾക്കും ഒരു കലണ്ടർ സൂക്ഷിക്കുക, വെബിലോ Aghosha മാനേജർ ആപ്പിലോ എല്ലാം നിയന്ത്രിക്കുക.',
  pgAboutWhyEyebrow: 'എന്തുകൊണ്ട് ഞങ്ങൾ ഇത് നിർമ്മിച്ചു',
  pgAboutWhyTitle: 'ഒരു വേദി ബുക്ക് ചെയ്യാൻ ഒരാഴ്ചത്തെ ഫോൺ വിളികൾ വേണ്ട',
  pgAboutWhy1:
    'സാധാരണ ഒരു വേദി കണ്ടെത്താൻ പലരോടും ചോദിക്കണം, ഹാളുകളെ ഓരോന്നായി വിളിക്കണം, തീയതി ഒഴിവുണ്ടോ ഹാൾ മതിയാകുമോ എന്നറിയും മുൻപേ നേരിട്ട് പോയി കാണണം.',
  pgAboutWhy2:
    'Aghosha വസ്തുതകൾ ആദ്യം കാണിക്കുന്നു: ഹാളിൽ എത്ര അതിഥികൾക്ക് ഇരിക്കാം, ഒരു സെഷന് എത്ര ചെലവ്, എന്തെല്ലാം സൗകര്യങ്ങൾ, ഏതെല്ലാം തീയതികൾ ഒഴിവുണ്ട്. വീട്ടിലിരുന്ന് തിരഞ്ഞെടുക്കാം, തയ്യാറാകുമ്പോൾ വേദിയുമായി സംസാരിക്കാം.',
  pgAboutWhyAlt: 'മേശപ്പുറത്ത് ആസൂത്രണ കുറിപ്പുകളും ലാപ്ടോപ്പും',
  pgHowEyebrow: 'എങ്ങനെ പ്രവർത്തിക്കുന്നു',
  pgHowTitle: 'ആദ്യ തിരച്ചിൽ മുതൽ സ്ഥിരീകരിച്ച ബുക്കിംഗ് വരെ',
  pgHowSub: 'Aghosha-യിലെ ബുക്കിംഗ് ഒരു അഭ്യർത്ഥനയാണ്, പണമടയ്ക്കലല്ല. വേദി അത് സ്ഥിരീകരിക്കും, പണം നേരിട്ട് വേദിക്ക് നൽകാം.',
  pgHowGuests: 'അതിഥികൾക്ക്',
  pgHowOwners: 'വേദി ഉടമകൾക്ക്',
  pgHowG1: 'കണ്ടെത്തുക',
  pgHowG1Body: 'നഗരം, തീയതി, പരിപാടി തരം, അതിഥികളുടെ എണ്ണം എന്നിവ വച്ച് തിരയുക. ഓരോ ലിസ്റ്റിംഗിലും ശേഷി, സൗകര്യങ്ങൾ, ഫോട്ടോകൾ, നിരക്കുകൾ ഉണ്ട്.',
  pgHowG2: 'താരതമ്യം ചെയ്യുക',
  pgHowG2Body: 'രണ്ട് വേദികൾ അടുത്തടുത്ത് വയ്ക്കുക, നിങ്ങളുടെ തീയതിയിലെ ഒഴിവുള്ള സെഷനുകൾ നോക്കുക, ബുക്ക് ചെയ്ത അതിഥികളുടെ അവലോകനങ്ങൾ വായിക്കുക.',
  pgHowG3: 'അഭ്യർത്ഥിക്കുക',
  pgHowG3Body: 'ഒരു സെഷൻ തിരഞ്ഞെടുത്ത് പരിപാടിയുടെ വിവരങ്ങളോടെ ബുക്കിംഗ് അഭ്യർത്ഥന അയയ്ക്കുക. ഓൺലൈനായി ഒന്നും അടയ്ക്കേണ്ടതില്ല.',
  pgHowG4: 'വേദി സ്ഥിരീകരിക്കും, പണം അവർക്ക്',
  pgHowG4Body:
    'വേദി അഭ്യർത്ഥന സ്ഥിരീകരിച്ചാൽ എസ്എംഎസ് അല്ലെങ്കിൽ വാട്ട്സ്ആപ്പ് വഴി അറിയിപ്പ് ലഭിക്കും. പണം വേദിയിൽ നേരിട്ട് നൽകുക.',
  pgHowO1: 'സൈൻ അപ്പ് ചെയ്യുക',
  pgHowO1Body: 'മൊബൈൽ നമ്പർ ഉപയോഗിച്ച് ഒരു വേദി അക്കൗണ്ട് തുടങ്ങുക.',
  pgHowO2: 'പരിശോധന പൂർത്തിയാക്കുക',
  pgHowO2Body:
    'സർക്കാർ തിരിച്ചറിയൽ രേഖയും ഒക്യുപൻസി സർട്ടിഫിക്കറ്റ് പോലുള്ള വേദി ലൈസൻസുകളും അപ്‌ലോഡ് ചെയ്യുക. ലൈവ് ആകുന്നതിന് മുൻപ് ഒരു Aghosha അഡ്മിൻ അവ പരിശോധിക്കും.',
  pgHowO3: 'വേദികൾ ലിസ്റ്റ് ചെയ്യുക',
  pgHowO3Body: 'ഓരോ വേദിക്കും ഫോട്ടോകൾ, ശേഷി, സൗകര്യങ്ങൾ, സെഷൻ സമയങ്ങൾ, നിരക്കുകൾ ചേർക്കുക.',
  pgHowO4: 'ബുക്കിംഗുകൾ നിയന്ത്രിക്കുക',
  pgHowO4Body: 'അഭ്യർത്ഥനകൾ സ്ഥിരീകരിക്കുക, പണമടവുകൾ രേഖപ്പെടുത്തുക, കലണ്ടർ പുതുക്കുക — വെബിലോ Aghosha മാനേജർ ആപ്പിലോ.',
  pgHowO5: 'സൂപ്പർവൈസർമാരെ ചേർക്കുക',
  pgHowO5Body: 'ബുക്കിംഗ് കലണ്ടർ കാണാൻ ജീവനക്കാർക്ക് സ്വന്തം ലോഗിൻ നൽകുക.',
  pgTrustEyebrow: 'എന്തുകൊണ്ട് വിശ്വസിക്കാം',
  pgTrustTitle: 'യഥാർത്ഥ വേദികൾ, യഥാർത്ഥ ലഭ്യത',
  pgTrust1: 'അഡ്മിൻ പരിശോധിച്ചത്',
  pgTrust1Body: 'ലിസ്റ്റിംഗ് ലൈവ് ആകുന്നതിന് മുൻപ് ഓരോ വേദി മാനേജരുടെയും തിരിച്ചറിയൽ രേഖയും വേദി ലൈസൻസുകളും ഒരു Aghosha അഡ്മിൻ പരിശോധിക്കുന്നു.',
  pgTrust2: 'കാണാവുന്ന ലഭ്യത',
  pgTrust2Body: 'ഒഴിവുള്ളതും ബുക്ക് ചെയ്തതുമായ സെഷനുകൾ വേദി Aghosha-യിൽ സൂക്ഷിക്കുന്ന കലണ്ടറിൽ നിന്നാണ്, അതിനാൽ ഒഴിവുള്ള തീയതികൾ മാത്രം അഭ്യർത്ഥിക്കാം.',
  pgTrust3: 'നിരക്കുകൾ മുൻകൂട്ടി',
  pgTrust3Body: 'സെഷൻ നിരക്കുകൾ ചോദിക്കും മുൻപേ ലിസ്റ്റിംഗിലുണ്ട്. പണം നൽകുന്നത് വേദിക്കാണ്, ഞങ്ങൾക്കല്ല.',
  pgTrust4: 'നിങ്ങളുടെ വിവരങ്ങൾ സ്വകാര്യം',
  pgTrust4Body: 'നിങ്ങൾ ബുക്ക് ചെയ്യുന്ന വേദി മാത്രമേ ബുക്കിംഗ് വിവരങ്ങൾ കാണൂ. ഞങ്ങൾ വിവരങ്ങൾ വിൽക്കുകയോ പരസ്യ ട്രാക്കറുകൾ ഉപയോഗിക്കുകയോ ചെയ്യുന്നില്ല.',
  pgTrustPrivacy: 'സ്വകാര്യതാ നയം വായിക്കുക',
  pgStatsEyebrow: 'Aghosha ഇന്ന്',
  pgStatsTitle: 'പ്ലാറ്റ്ഫോമിൽ നിന്ന് തത്സമയം',
  pgStatVenues: { one: 'ലിസ്റ്റ് ചെയ്ത വേദി', other: 'ലിസ്റ്റ് ചെയ്ത വേദികൾ' },
  pgStatCities: { one: 'നഗരം', other: 'നഗരങ്ങൾ' },
  pgStatCapacity: 'ഏറ്റവും വലിയ വേദിയിലെ അതിഥികൾ',
  pgStatEvents: { one: 'സ്ഥിരീകരിച്ച പരിപാടി', other: 'സ്ഥിരീകരിച്ച പരിപാടികൾ' },
  pgStatRating: 'ശരാശരി അതിഥി റേറ്റിംഗ്',
  pgFaqEyebrow: 'ചോദ്യങ്ങൾ',
  pgFaqTitle: 'ചോദ്യങ്ങളും ഉത്തരങ്ങളും',
  pgFaq1: 'ബുക്കിംഗ് ഫീസ് ഉണ്ടോ?',
  pgFaq1A:
    'ഇല്ല. Aghosha-യിൽ തിരയുന്നതും ബുക്കിംഗ് അഭ്യർത്ഥന അയയ്ക്കുന്നതും അതിഥികൾക്ക് സൗജന്യമാണ്. ലിസ്റ്റിംഗിൽ കാണിക്കുന്ന വേദിയുടെ നിരക്ക് വേദിക്ക് തന്നെ നൽകിയാൽ മതി.',
  pgFaq2: 'എങ്ങനെയാണ് പണം നൽകേണ്ടത്?',
  pgFaq2A:
    'നേരിട്ട് വേദിയിൽ. ബുക്ക് ചെയ്യുമ്പോൾ അഡ്വാൻസ് ഒന്നും നൽകേണ്ടതില്ല — വേദി സ്ഥിരീകരിച്ചാൽ കാണിച്ച തുക വേദിയിൽ നൽകുക. Aghosha ഓൺലൈനായി പണം സ്വീകരിക്കുന്നില്ല, അതിനാൽ നിങ്ങളുടെ കാർഡ്, ബാങ്ക് വിവരങ്ങൾ ഞങ്ങളിലെത്തില്ല.',
  pgFaq3: 'വേദി എന്റെ ബുക്കിംഗ് സ്ഥിരീകരിക്കുമോ?',
  pgFaq3A:
    'അതെ. നിങ്ങളുടെ അഭ്യർത്ഥന വേദിയുടെ മാനേജർക്ക് എത്തും, അവരാണ് സ്ഥിരീകരിക്കുക. അതുവരെ സ്ലോട്ട് നിങ്ങൾക്കായി മാറ്റിവയ്ക്കില്ല. സ്ഥിതി നിങ്ങളുടെ ബുക്കിംഗുകളിൽ കാണാം, എസ്എംഎസ് അല്ലെങ്കിൽ വാട്ട്സ്ആപ്പ് വഴി അറിയിപ്പും ലഭിക്കും.',
  pgFaq4: 'എനിക്ക് റദ്ദാക്കാമോ?',
  pgFaq4A:
    'അതെ, നിങ്ങളുടെ ബുക്കിംഗുകളിൽ നിന്ന്. വേദി സ്ഥിരീകരിക്കാത്ത അഭ്യർത്ഥന ചെലവില്ലാതെ പിൻവലിക്കാം. വേദിക്ക് പണം നൽകിയിട്ടുണ്ടെങ്കിൽ തിരികെ ലഭിക്കുന്നത് പരിപാടി എത്ര അടുത്താണ് എന്നതിനെ ആശ്രയിച്ചാണ്: 48 മണിക്കൂറോ അതിലധികമോ മുൻപ് മുഴുവനും, 12 മുതൽ 48 മണിക്കൂർ വരെ പകുതിയും, അവസാന 12 മണിക്കൂറിൽ ഒന്നുമില്ല. വേദി പണം നേരിട്ട് നിങ്ങൾക്ക് തിരികെ നൽകും.',
  pgFaq5: 'വേദി യഥാർത്ഥമാണെന്ന് എങ്ങനെ അറിയാം?',
  pgFaq5A:
    'ഒരു വേദി ലൈവ് ആകുന്നതിന് മുൻപ് മാനേജരുടെ സർക്കാർ തിരിച്ചറിയൽ രേഖയും ഒക്യുപൻസി സർട്ടിഫിക്കറ്റ് പോലുള്ള വേദി ലൈസൻസുകളും ഒരു Aghosha അഡ്മിൻ പരിശോധിക്കുന്നു. അവലോകനങ്ങൾ ബുക്ക് ചെയ്ത അതിഥികളിൽ നിന്ന് മാത്രമാണ്.',
  pgFaq6: 'ബുക്ക് ചെയ്യും മുൻപ് വേദി സന്ദർശിക്കാമോ?',
  pgFaq6A:
    'തീർച്ചയായും. ഓരോ ലിസ്റ്റിംഗിലും വേദിയുടെ വിലാസവും ഫോൺ നമ്പറുമുണ്ട്, വിളിച്ച് സന്ദർശനം ക്രമീകരിക്കാം. പല ലിസ്റ്റിംഗുകളിലും നിരവധി ഫോട്ടോകളും ചിലതിൽ 360° കാഴ്ചയുമുണ്ട്.',
  pgFaq7: 'സൈറ്റ് മലയാളത്തിൽ ലഭ്യമാണോ?',
  pgFaq7A:
    'അതെ. ഭാഷാ മെനുവിൽ നിന്ന് എപ്പോൾ വേണമെങ്കിലും ഇംഗ്ലീഷിനും മലയാളത്തിനും ഇടയിൽ മാറാം. ചില ആസൂത്രണ ഗൈഡുകളും വേദി വിവരണങ്ങളും ഇംഗ്ലീഷിൽ മാത്രമാണ്.',
  pgFaq8: 'എന്റെ വേദി എങ്ങനെ ലിസ്റ്റ് ചെയ്യാം?',
  pgFaq8A:
    '“വേദി ചേർക്കുക” തിരഞ്ഞെടുത്ത് മൊബൈൽ നമ്പർ ഉപയോഗിച്ച് സൈൻ അപ്പ് ചെയ്യുക, തിരിച്ചറിയൽ രേഖയും വേദി ലൈസൻസുകളും അപ്‌ലോഡ് ചെയ്യുക. അഡ്മിൻ അക്കൗണ്ട് അംഗീകരിച്ചാൽ വേദികൾ ചേർത്ത് അഭ്യർത്ഥനകൾ സ്വീകരിച്ചു തുടങ്ങാം.',
  pgFaq9: 'Aghosha മാനേജർ ആപ്പ് എന്താണ്?',
  pgFaq9A:
    'വേദി ഉടമകൾക്കും ജീവനക്കാർക്കുമുള്ള മൊബൈൽ ആപ്പ്. മാനേജർമാർക്ക് ബുക്കിംഗ് അഭ്യർത്ഥനകൾ കണ്ട് മറുപടി നൽകാം, കലണ്ടർ നോക്കാം, പുതിയ ബുക്കിംഗുകളുടെ അറിയിപ്പ് ലഭിക്കും. കലണ്ടർ മാത്രം കാണുന്ന സൂപ്പർവൈസർമാരെയും ചേർക്കാം.',
  pgFaq10: 'എന്റെ വിവരങ്ങൾ എങ്ങനെ ഉപയോഗിക്കുന്നു?',
  pgFaq10A:
    'നിങ്ങളുടെ ബുക്കിംഗ് നടത്താൻ മാത്രം. നിങ്ങൾ ബുക്ക് ചെയ്യുന്ന വേദി നിങ്ങളുടെ പേര്, നമ്പർ, ബുക്ക് ചെയ്തത് എന്നിവ കാണും. ഞങ്ങൾ വിവരങ്ങൾ വിൽക്കുന്നില്ല, സൈറ്റിൽ പരസ്യ ട്രാക്കറുകളുമില്ല. വിശദാംശങ്ങൾ സ്വകാര്യതാ നയത്തിലുണ്ട്.',
  pgFaqMoreTitle: 'ഇനിയും ചോദ്യമുണ്ടോ?',
  pgFaqMoreBody: 'ഞങ്ങൾക്ക് എഴുതുകയോ വിളിക്കുകയോ ചെയ്യൂ. ശരിയായ വേദി കണ്ടെത്താൻ സന്തോഷത്തോടെ സഹായിക്കാം.',
  pgAboutOperator: 'Aghosha നിർമ്മിച്ച് നടത്തുന്നത് കേരളത്തിലെ കൊച്ചിയിലുള്ള {operator} ആണ്.',
  pgAboutCtaTitle: 'ഒരു തിരച്ചിലിൽ നിന്ന് തുടങ്ങൂ',
  // night edition: shared
  pgEventType: 'പരിപാടിയുടെ തരം',
  pgOccPicker: 'പരിപാടിയുടെ തരം തിരഞ്ഞെടുക്കുക',
  pgOccHeroTitle: '{name} വേദികൾ',
  pgOccTipsEyebrow: 'ആസൂത്രണ നിർദ്ദേശങ്ങൾ',
  pgOccPlanning: '{name}: ആസൂത്രണം',
  pgOccSearchThese: 'ഈ വേദികൾ തിരയുക',
  pgOccSuitableWord: { one: 'അനുയോജ്യമായ വേദി', other: 'അനുയോജ്യമായ വേദികൾ' },
  pgOccSummary: '{name} പരിപാടികൾക്ക് സാധാരണ ഇണങ്ങുന്ന ഘടനയും സൗകര്യങ്ങളുമുള്ള വേദികൾ. തീയതികളും വിവരങ്ങളും ഓരോ വേദിയുമായി ഉറപ്പാക്കുക.',
  pgFactVenues: 'അനുയോജ്യമായ വേദികൾ',
  pgFactUpTo: 'പരമാവധി',
  pgFactGuests: 'അതിഥികൾ',
  pgFactFrom: 'മുതൽ',
  pgFactCities: 'നഗരങ്ങൾ',
  pgLocCityWord: { one: 'വേദികളുള്ള നഗരം', other: 'വേദികളുള്ള നഗരങ്ങൾ' },
  pgHowFor: 'ആർക്കുള്ള ഘട്ടങ്ങൾ',
  pgAboutFinalTitle: 'നിങ്ങളുടെ നഗരത്തിലെ വേദികൾ കാണുക',
  pgAboutFinalBody: 'യഥാർത്ഥ ശേഷി, നിരക്ക്, ഒഴിവുള്ള തീയതികൾ.',
  pgOnThisPage: 'ഈ പേജിൽ',
  pgCtSentTitle: 'സന്ദേശം അയച്ചു',
  pgCtSentBody: 'നന്ദി. ഞങ്ങൾ ഉടൻ നിങ്ങളെ ബന്ധപ്പെടും.',
  pgCtSendAnother: 'മറ്റൊരു സന്ദേശം അയയ്ക്കുക',
  pgCtSubBooking: 'വേദി ബുക്ക് ചെയ്യൽ',
  pgCtSubListing: 'എന്റെ വേദി ചേർക്കൽ',
  pgCtSubAccount: 'അക്കൗണ്ട് അല്ലെങ്കിൽ ലോഗിൻ',
  pgCtSubOther: 'മറ്റെന്തെങ്കിലും',
  pgCtMessageError: 'നിങ്ങൾക്ക് എന്താണ് വേണ്ടതെന്ന് ചുരുക്കി പറയൂ.',
};
